export default [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '主题名称',
    field: 'name',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '主题编号',
    field: 'code'
  },
  {
    headerName: '主题分类名称',
    field: 'programCategoryName'
  },
  {
    headerName: '学员账号',
    field: 'account'
  },
  {
    headerName: '学员姓名',
    field: 'fullName'
  },
  {
    headerName: '账号状态',
    field: 'accountState'
  },
  {
    headerName: '上级组织',
    field: 'leadName'
  },
  {
    headerName: '组织名称',
    field: 'orgName'
  },
  {
    headerName: '组织编码',
    field: 'orgCode'
  },
  {
    headerName: '组织类型',
    field: 'nodeCategoryName',
  },
  {
    headerName: '省份',
    field: 'province'
  },
  {
    headerName: '岗位名称',
    field: 'positionName'
  },
  {
    headerName: '任职状态',
    field: 'jobState'
  },
  {
    headerName: '班级名称',
    field: 'className'
  },
  {
    headerName: '班级开始时间',
    field: 'classStartDate'
  },
  {
    headerName: '班级结束时间',
    field: 'classEndDate'
  },
  {
    headerName: '成绩',
    field: 'score'
  },
  {
    headerName: '状态',
    field: 'pass'
  },
  {
    headerName: '成绩获得时间',
    field: 'scoreDate'
  },
  {
    headerName: '提交报名时间',
    field: 'applyDate'
  },
  {
    headerName: '报名状态',
    field: 'applyStatus'
  },
  {
    headerName: '培训天数',
    field: 'studyDay'
  },
  {
    headerName: '出勤情况',
    field: 'attendanceState'
  },
  {
    headerName: '评语',
    field: 'comment'
  }
]
